import { render, staticRenderFns } from "./SelectDeptTree.vue?vue&type=template&id=0bf0b59e&scoped=true&"
import script from "./SelectDeptTree.vue?vue&type=script&lang=js&"
export * from "./SelectDeptTree.vue?vue&type=script&lang=js&"
import style0 from "./SelectDeptTree.vue?vue&type=style&index=0&id=0bf0b59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf0b59e",
  null
  
)

export default component.exports